var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M4.708,13.215a1.208,1.208,0,0,1-1.708,0L.354,10.568A1.208,1.208,0,0,1,2.062,8.861l1.577,1.577a.306.306,0,0,0,.432,0L8.34,6.168a1.208,1.208,0,1,1,1.708,1.708Z","transform":"translate(2.5 -2)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }